<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Client Report'"></Teranet-PageTitle>
    <form [formGroup]="reportForm" #createform="ngForm" (ngSubmit)="submit()" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Report Criteria'" [IconName]="'filter'"></Teranet-ClientTitle>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Report Name</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              formControlName="genericReportType"
                              [(ngModel)]="reportCriteriaModel.reportType"
                              (selectionChange)="BindReportDates()"
                              placeholder="--Please Select--">
                    <mat-option *ngFor="let item of reportTypes" [value]="item.value">
                      {{ item.text }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="reportForm.get('genericReportType').hasError('required')">
                    Report name is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <Teranet-MonthDayYearPicker [disabled]="false"
                                            [label]="'From Date'"
                                            [error]="reportForm.get('reportFromDate').errors?.required
                                        ? 'test'
                                        : ''"
                                            [classCss]="'mat-form-field-lg'"
                                            [required]="true"
                                            formControlName="reportFromDate"></Teranet-MonthDayYearPicker>
              </div>
              <div class="form-group-flex-column">
                <Teranet-MonthDayYearPicker [disabled]="false"
                                            [label]="'To Date'"
                                            [error]="reportForm.get('reportToDate').errors?.required
                                        ? 'Report To date is required'
                                        : ''"
                                            [classCss]="'mat-form-field-lg'"
                                            [required]="true"
                                            formControlName="reportToDate"></Teranet-MonthDayYearPicker>
              </div>
            </div>
            <div class="form-group-flex-column">
              <mat-label *ngIf="!hideMessage && message.length != 0">{{ message }}</mat-label>
              <mat-error *ngIf="hideMessage && message.length != 0">{{ message }}</mat-error>
            </div>
            <div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="end">
              <button mat-raised-button class="plain-button-lg" type="reset" (click)="reset()">Clear Criteria</button>
              <button mat-raised-button class="theme-button-lg" [disabled]="!reportForm.valid">Download Report</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100" [hidden]="isHideGrid">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="fileList"
                            [gridName]="'file-list'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="GridDefaultSettings()"
                            [isFinishLoading]="true"
                            [isExportExcel]="false"
                            [pageName]="'file-list'"></Teranet-CustomizedGrid>
  </div>
</div>
